module.exports = __webpack_public_path__ + "img/star-fill.e2086be8.svg";